import axios from "axios";
import stateCodes from "../components/statesCode";
const url =
  "https://secret-lake-84006.herokuapp.com/https://api.covid19tracker.in/data/static/data.min.json";

export const fetchData = async (state) => {
  if (state) {
    try {
      const { data } = await axios.get(url, {
        headers: { "Access-Control-Allow-Origin": "*" },
      });
      var st = Object.keys(stateCodes).filter(function (key) {
        return stateCodes[key] === state;
      })[0];
      st = data[st];
      const modifiedData = {
        confirmed: st.total.confirmed,
        active: st.total.confirmed - (st.total.recovered + st.total.deceased),
        recovered: st.total.recovered,
        deaths: st.total.deceased,
        lastupdatedtime: st.meta.last_updated,
        deltaconfirmed:
          st?.delta?.confirmed !== undefined ? st.delta.confirmed : 0,
        deltadeaths:
          st?.delta7?.deceased !== undefined ? st.delta7.deceased : 0,
        deltarecovered:
          st?.delta?.recovered !== undefined ? st.delta.recovered : 0,
      };
      return modifiedData;
    } catch (error) {
      console.log(error);
    }
  } else {
    try {
      const { data } = await axios.get(url);
      const modifiedData = {
        confirmed: data.TT.total.confirmed,
        active:
          data.TT.total.confirmed -
          (data.TT.total.recovered + data.TT.total.deceased),
        recovered: data.TT.total.recovered,
        deaths: data.TT.total.deceased,
        lastupdatedtime: data.TT.meta.last_updated,
        deltaconfirmed: data.TT.delta.confirmed,
        deltadeaths: data.TT.delta7.deceased,
        deltarecovered: data.TT.delta.recovered,
      };
      return modifiedData;
    } catch (error) {
      console.log(error);
    }
  }
};

export const fetchDailyData = async () => {
  try {
    const { data } = await axios.get(
      "https://secret-lake-84006.herokuapp.com/https://api.covid19tracker.in/data/static/timeseries.min.json"
    );
    const allState = data["TT"].dates;
    var modifiedData = [];
    for (var key of Object.keys(allState)) {
      modifiedData.push({
        totalconfirmed: allState[key].total.confirmed,
        totaldeceased: allState[key].total.deceased,
        totalrecovered: allState[key].total.recovered,
        date: key,
      });
    }
    return modifiedData;
  } catch (error) {
    console.log(error);
  }
};

export const fetchStates = async () => {
  try {
    const { data } = await axios.get(url);
    const state = Object.keys(data);
    return state.map((code) => stateCodes[code]);
  } catch (error) {
    console.log(error);
  }
};

export const fetchDistrict = async (state) => {
  if (state) {
    try {
      const { data } = await axios.get(url);
      var st = Object.keys(stateCodes).filter(function (key) {
        return stateCodes[key] === state;
      })[0];
      st = data[st].districts;

      return st;
    } catch (error) {
      console.log(error);
    }
  }
};

export const fetchMap = async () => {
  try {
    const { data } = await axios.get(url);

    var modifiedData = [];
    for (var key of Object.keys(data)) {
      modifiedData.push({
        id: key,
        state: stateCodes[key],
        value: data[key].total.confirmed,
      });
    }
    return modifiedData;
  } catch (error) {
    console.log(error);
  }
};
